import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const CartFrameToDownload = (props: QRFRameToPrintProps): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 83.332031 354.078125 C 123.515625 354.078125 163.695312 354.078125 203.878906 354.078125 C 235.402344 514.984375 267.550781 675.773438 300.3125 836.441406 C 463.179688 838.316406 626.050781 838.582031 788.917969 837.242188 C 812.222656 730.34375 835.527344 623.421875 858.835938 516.472656 C 874.625 520.328125 890.429688 524.082031 906.25 527.726562 C 906.25 529.871094 906.25 532.015625 906.25 534.160156 C 880.074219 651.128906 854.898438 768.503906 830.707031 886.285156 C 788.917969 886.015625 747.128906 886.285156 705.34375 887.085938 C 747.558594 901.042969 766.042969 930.253906 760.792969 974.714844 C 752.730469 1003.949219 734.246094 1022.707031 705.34375 1030.992188 C 694.628906 1030.992188 683.914062 1030.992188 673.195312 1030.992188 C 624.242188 1012.898438 607.363281 978.597656 622.570312 928.089844 C 633.367188 907 650.242188 893.332031 673.195312 887.085938 C 587.476562 886.015625 501.757812 886.015625 416.035156 887.085938 C 458.253906 901.042969 476.738281 930.253906 471.488281 974.714844 C 463.425781 1003.949219 444.941406 1022.707031 416.035156 1030.992188 C 405.320312 1030.992188 394.605469 1030.992188 383.890625 1030.992188 C 334.933594 1012.898438 318.058594 978.597656 333.261719 928.089844 C 344.0625 907 360.9375 893.332031 383.890625 887.085938 C 342.105469 886.285156 300.316406 886.015625 258.523438 886.285156 C 226.960938 725.996094 195.082031 565.742188 162.894531 405.53125 C 136.757812 402.351562 110.238281 401.28125 83.332031 402.3125 C 83.332031 386.234375 83.332031 370.15625 83.332031 354.078125 Z M 391.925781 936.128906 C 414.671875 933.960938 424.585938 944.144531 421.660156 966.675781 C 412.234375 982.347656 399.644531 985.296875 383.890625 975.519531 C 373.292969 959.464844 375.972656 946.335938 391.925781 936.128906 Z M 681.234375 936.128906 C 703.980469 933.960938 713.890625 944.144531 710.96875 966.675781 C 701.542969 982.347656 688.949219 985.296875 673.195312 975.519531 C 662.597656 959.464844 665.277344 946.335938 681.234375 936.128906 Z M 681.234375 936.128906 "
        />

        <path
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
          d="M 302.082031 177.039062 L 781.25 177.039062 C 792.757812 177.039062 802.082031 186.363281 802.082031 197.867188 L 802.082031 676.914062 C 802.082031 688.417969 792.757812 697.742188 781.25 697.742188 L 302.082031 697.742188 C 290.578125 697.742188 281.25 688.417969 281.25 676.914062 L 281.25 197.867188 C 281.25 186.363281 290.578125 177.039062 302.082031 177.039062 Z M 302.082031 177.039062 "
        />

        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1120.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
